module.exports = __webpack_public_path__ + "static/media/img-goal-9.e5f4af92.jpg";